import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16f2bdfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"none"} }, null, -1))
const _hoisted_2 = { class: "ai-interp-content" }
const _hoisted_3 = { class: "ai-header" }
const _hoisted_4 = { class: "ai-title" }
const _hoisted_5 = { class: "ai-update-time" }
const _hoisted_6 = { class: "ai-reason" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-disclaimer" }, " 上述股票解读内容完全由DeepSeek自动化生成，引用内容来源于互联网，用户应交叉验证AI生成内容，避免单一依赖。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    footer: null,
    centered: true,
    width: 650,
    transitionName: '',
    maskTransitionName: '',
    getContainer: _ctx.getContainer,
    closable: true,
    class: "ai-interp-modal-wrapper"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.displayName) + " AI解读", 1),
          _createElementVNode("div", _hoisted_5, "更新时间 " + _toDisplayString(_ctx.formatTime(_ctx.updateTime)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.displayReason), 1),
        _hoisted_7
      ])
    ]),
    _: 1
  }, 8, ["visible", "getContainer"]))
}